import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { apiResult } from '../models/api-result.interface';
import { ApiService } from '../services/api/api.service';
import { StorageService } from '../services/storage/storage.service';

/**
 * Exige assinatura Boozap Descontos ativa para rotas de benefício.
 * Fonte da verdade: GET `usuariosplataformadescontos?status=Ativo` apenas —
 * não usar `status_cadastro` aprovado nem `Não contratado` como ativo (ST-ASS-07).
 */
export const assinaturaAtivaGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const storage = inject(StorageService);
  const api = inject(ApiService);

  const jwt = await storage.get('jwt');
  if (!jwt) {
    return router.createUrlTree(['/auth/login']);
  }

  try {
    const sub: apiResult = await api.get('usuariosplataformadescontos', {
      status: 'Ativo',
    });
    const assinaturas = Array.isArray(sub.data) ? sub.data : [];
    if (assinaturas.length > 0) {
      return true;
    }
  } catch {
    return router.createUrlTree(['/minhas-assinaturas']);
  }

  return router.createUrlTree(['/minhas-assinaturas']);
};
